import React, { FC } from 'react'

interface Props {
  size?: number
}

export const KofiIcon: FC<Props> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="16" fill="#3E85E9" />
    <rect
      x="0.214286"
      y="0.214286"
      width="31.5714"
      height="31.5714"
      rx="15.7857"
      stroke="white"
      strokeOpacity="0.2"
      strokeWidth="0.428571"
    />
    <path
      d="M22.9195 10C24.4222 10.0006 27.3335 10.751 27.3335 13.804C27.3335 17.701 24.0003 17.7955 23.6708 17.7956C23.4466 17.7956 23.0697 17.7716 22.8375 17.7552C22.2865 21.3399 19.0059 23.9771 15.2756 23.6029L14.8322 23.5586C11.4329 23.2174 8.82204 20.3941 8.74696 16.9785L8.66753 13.3724C8.62853 11.5942 10.0504 10.1269 11.829 10.1094L22.8244 10.0007L22.8251 10H22.9195ZM23.7125 12.1126C23.2328 12.052 22.8299 12.4716 22.8355 12.9551L22.8596 15.0052C22.8656 15.5121 23.2766 15.9476 23.7769 15.8659C24.5391 15.7411 25.3609 15.3277 25.3609 14.0137C25.3608 12.5755 24.501 12.2123 23.7125 12.1126Z"
      fill="white"
    />
    <path
      d="M15.6947 19.7588C15.6947 19.7588 17.6918 17.999 18.5915 16.9857C19.3926 16.0791 19.4446 14.5505 18.0694 13.9788C16.6952 13.4075 15.5647 14.6505 15.5647 14.6505C14.5843 13.6089 13.1007 13.6618 12.4139 14.3664C11.7276 15.071 11.9676 16.281 12.4794 16.9543C12.9604 17.5857 15.0729 19.4046 15.393 19.7122C15.4175 19.7348 15.4436 19.7558 15.471 19.775C15.6075 19.842 15.6947 19.7588 15.6947 19.7588Z"
      fill="#FF5A16"
    />
  </svg>
)
